import { Component, OnInit } from '@angular/core';
import { faBell, faCog, faSignOutAlt, faBars, faSignInAlt, faUserCog, faUser, faUserAlt,faQuestion } from '@fortawesome/free-solid-svg-icons';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { Logout } from 'src/app/interfaces/services/user.interface';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { HasSubscription } from 'src/app/interfaces/services/subscription.interface';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { CloudHelpService } from 'src/app/services/cloud-help.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.sass']
})
export class NavbarComponent implements OnInit, Logout, HasSubscription {
  loggedIn = true;
  username = 'Demo User';

  faBell = faBell;
  faCog = faCog;
  faSignOutAlt = faSignOutAlt;
  faBars = faBars;
  faSignInAlt = faSignInAlt;
  faUserCog = faUserCog;
  faUser = faUser;
  faQuestion = faQuestion

  isAuthenticated: boolean;
  hasFreeTrial:boolean;
  isNotificationPanelOpen = false;
  isHelpPanelOpen : boolean = false

  logoButtonUrl = '';

  public user;
  public companyName;
  public userIdName;
  notificationCount = 0;

  constructor(private readonly localStorage: LocalStorageService, public router: Router, private authSvc: CloudAuthenticationService, public profileService: CloudProfileService,
    public notificationSvc: CloudNotificationService, private subscriptionService: CloudSubscriptionService,public helpService:CloudHelpService) {
      router.events.subscribe((e)=>{
        if(e instanceof NavigationEnd){
          if (!e.url.startsWith('/subscription/create')) this.isAuthenticated = this.authSvc.isAuthenticated();
        }
      })
     }

  ngOnInit(): void {
    this.logoButtonUrl = environment.routes.subscription;
    this.user = this.profileService.getUser();
    this.userIdName = this.profileService.getUserName();
    this.companyName = this.profileService.getCompanyNameasObservable();
    this.notificationSvc.panelDisplayStatus.subscribe(_ => {
      this.isNotificationPanelOpen = _;
    });
    this.notificationSvc.notificationCountSubject.subscribe(count => {
      this.notificationCount = count;
    });
    this.helpService.helpPanelDispalyStatus.subscribe(_ =>{
      this.isHelpPanelOpen = _
    })
  }

  redirectToHome() {
    this.localStorage.removeItem('deploymentRedirection');
    this.router.navigate([this.logoButtonUrl]);
  }

  logout(): boolean {
    // window.location.reload();
    quotationGlobalState.resetQuotationGlobalState()
    quotationGlobalState.resetSubscriptionId()
    return this.authSvc.logout();
  }

  hasSubscription() {
    return this.subscriptionService.hasSubscription();
  }

  showLoginBtn(): boolean {
    if (this.router.url.includes('/auth/login') || this.router.url === '/') {
      return false;
    }
    else {
      return true;
    }
  }

  triggerHelpPanel(value : boolean){
    this.helpService.helpPanelDispalyStatus.next(value)
    this.notificationSvc.panelDisplayStatus.next(false)
  }


}
